(function() {
    'use strict';
    /**
     * @memberof app
     *@ngdoc service
     *@name mobileService
     *@description
     *Servicio de autores
     */

    angular
        .module('app')
        .factory('mobileService', mobileService);

    mobileService.$inject = ["$window"];

    function mobileService($window) {    

    	var mobile = {};
    	var helper = {};
    	var variable = {};
    	var sizes = ['desktop','tablet','mobile'];
    	/**
        * @ngdoc method
        * @name getPagina
        * @memberof mobileService
        * @desciption
        * Obtienes las mobile.
        */
    	
    	mobile.set = function(key,value,size)
    	{
    		if(!variable[key])
    			variable[key] = {};
    		variable[key][size] = value;
    	};

    	mobile.get = function(key,defa)
    	{
    		var size = mobile.getsize();
    		if(variable[key]){
    			if(variable[key][size]){
    				return variable[key][size];
    			}
    			else{
    				return defa;
    			}
    		}else{
    			return defa;
    		}

    	};
    	
    	mobile.getsize = function()
    	{
    		var s = "desktop";
    		if(mobile.isMobile())
    			s='mobile';
    		if(mobile.isTablet())
    			s = "tablet";

    		return s;
    	};

        mobile.isMobile      = function () { 
   	        var winWidth = $window['outerWidth'];
        	return helper.isSmartDevice() && (winWidth <= 767);   
        };

        mobile.isTablet      = function () { 
   	        var winWidth = $window['outerWidth'];
        	return helper.isSmartDevice() && (winWidth > 767);    
        };

        mobile.isDesktop     = function () { 
   	        var winWidth = $window['outerWidth'];
        	return !helper.isSmartDevice();                       
        };


        helper.isSmartDevice = function()
    	{
        	// Adapted from http://www.detectmobilebrowsers.com
        	var ua = $window['navigator']['userAgent'] || $window['navigator']['vendor'] || $window['opera'];

        	// Checks for iOs, Android, Blackberry, Opera Mini, and Windows mobile devices
        	return (/iPhone|iPod|iPad|Silk|Android|BlackBerry|Opera Mini|IEMobile/).test(ua);
    	};


    	return mobile;
    }



})();
